import React from "react";
import SeriesInfoPage from "../catalogue/SeriesInfoPage";
import { getPodcastGC } from "../../../store/actions/uploadMediaAction";
import { getPodcast } from "../../../services/podcasts";

const ViewPodcast = () => (
  <SeriesInfoPage
    idParam="podcast_id"
    load={getPodcast}
    storeKey="generalContentObjPodcast"
    setInfo={getPodcastGC}
    pagePath={(id) => `/dashboard/podcast-info/${id}`}
    tagSuffix="-podcast"
  />
);

export default React.memo(ViewPodcast);
